var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43242 14.086L5.73625 16.6849L3.19176 16.7388C2.43133 15.3283 2 13.7146 2 11.9998C2 10.3415 2.40328 8.77779 3.11812 7.40088H3.11867L5.38398 7.81619L6.37633 10.0679C6.16863 10.6734 6.05543 11.3234 6.05543 11.9998C6.05551 12.7338 6.18848 13.4372 6.43242 14.086Z",
    fill: "#FBBB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8252 10.1321C21.94 10.737 21.9999 11.3617 21.9999 12.0002C21.9999 12.7161 21.9246 13.4145 21.7812 14.0881C21.2944 16.3804 20.0224 18.3821 18.2604 19.7986L18.2598 19.798L15.4065 19.6524L15.0027 17.1315C16.1719 16.4458 17.0857 15.3727 17.567 14.0881H12.2197V10.1321H17.645H21.8252Z",
    fill: "#518EF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.26 19.7977L18.2606 19.7983C16.5469 21.1757 14.3699 21.9999 12.0001 21.9999C8.19189 21.9999 4.88092 19.8713 3.19189 16.7389L6.43256 14.0862C7.27705 16.34 9.45123 17.9444 12.0001 17.9444C13.0957 17.9444 14.1221 17.6483 15.0029 17.1312L18.26 19.7977Z",
    fill: "#28B446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.383 4.30219L15.1434 6.95437C14.2319 6.38461 13.1544 6.05547 12 6.05547C9.39344 6.05547 7.17859 7.73348 6.37641 10.0681L3.11871 7.40109H3.11816C4.78246 4.1923 8.1352 2 12 2C14.4264 2 16.6511 2.8643 18.383 4.30219Z",
    fill: "#F14336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.8521f9e746fe027b7c7f3facadded591.svg";
export { ForwardRef as ReactComponent };